import * as ListTypes from '$shared/atoms/ListTypes/index';

export class NpiProfileAddress {
  private readonly data: ObjectType<any>;

  constructor(data: ObjectType<any>) {
    if (!data) return;
    this.data = data;
  }

  public get purpose(): string {
    return this.data?.purpose || '';
  }

  public toList(): DataListAsComponent {
    return {
      component: ListTypes.AddressListType,
      props: { value: this.data }
    };
  }
}
